function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import useStyles from 'isomorphic-style-loader/useStyles';
import * as selectors from '../../selectors';
import messages from '../../messages';
import BackBtn from './BackBtn';
import styles from './info.pcss';
const Info = ({ returnUrl })=>{
    useStyles(styles);
    const resetPasswordEmail = useSelector(selectors.resetPasswordEmail);
    const resetPasswordType = useSelector(selectors.resetPasswordType);
    const verifiedSignatureToken = useSelector(selectors.verifiedSignatureToken);
    if (verifiedSignatureToken) {
        return null;
    }
    let messageKey;
    if (resetPasswordType) {
        messageKey = resetPasswordType === 'code' ? 'resetPasswordCode' : 'resetPasswordSent';
    } else {
        messageKey = 'resetPassword';
    }
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "text--paragraph text--center mb-5 mx-5",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.intros[messageKey]), {
                    values: {
                        resetPasswordEmail: /*#__PURE__*/ _jsx("b", {
                            className: styles.email,
                            children: resetPasswordEmail
                        })
                    }
                }))
            }),
            resetPasswordType === 'email' && /*#__PURE__*/ _jsx(BackBtn, {
                returnUrl: returnUrl
            })
        ]
    });
};
export default Info;
